<style scoped>
@import url("../assets/css/index.css");
</style>

<template>
  <div :class="is_weixin || is_app?'':'common-home-content'">
    <transition name="slide-fade">
      <div class="zyzk" v-if="zyzk_show">中医智库</div>
    </transition>
    <div class="home-header" v-if="!is_weixin && !is_app">
      <span class="title">智慧开方</span>
    </div>
    <div class="page-loading" v-show="!show">
      <div class="loading-content">
        <img src="../assets/images/page_loading.gif">
        <p class="title">正在加载...</p>
      </div>
    </div>
    <div style="background-color: #fff;" v-show="show">
      <div class="sex-btns-content space_pl space_pr">
        <div class="sex-btns clearfix">
          <button
              class="sex-btn sex0 fl"
              :class="sex_id == 0?'active':''"
              @click="menuClick(0, 0)"
          >男</button>
          <button
              class="sex-btn sex1 fl"
              :class="sex_id == 1?'active':''"
              @click="menuClick(1, 0)"
          >女</button>
          <button
              class="sex-btn sex2 fl"
              :class="sex_id == 2?'active':''"
              @click="menuClick(2, 0)"
          >儿童</button>
          <img @click="goto" class="sex2 fl imgs" style="" src="../assets/images/2.png" alt="">
        </div>
      </div>
      <div class="mt15 pb15 space_pl space_pr">
        <h2 class="recommend-title">{{rTitle}}</h2>
        <ul class="recommend-list clearfix">
          <li
              class="fl" data-trace=""
              v-for="(category,index) in categories"
              :key="index"
              @click="question(category.trace)"
          >
            <div class="box">{{category.text}}</div>
          </li>
        </ul>
      </div>
      <div class="disease-content clearfix">
        <div class="disease-sort fl">
          <ul class="disease-sort-ul">
            <li
                :class="sort_index == index?'active':''"
                v-for="(sort,index) in sorts"
                :key="index"
                @click="menuClick(index, 1)"
            >
              <span class="sort-icon" :class="'icon-'+sort.icon"></span>{{sort.text}}
            </li>
          </ul>
        </div>
        <div class="disease-list fr">
          <ul class="disease-select">
            <li
                v-for="(disease,index) in diseases"
                :key="index"
                @click="question(disease.trace)"
            >
              <span class="text">{{disease.text}}</span>
              <span class="arrow_box"></span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {deviceType} from '../utils/deviceType'
import http from '../assets/api/athenaApiConfig'
export default {
  data() {
    return {
      locData: {},
      categories: null,
      sorts: null,
      diseases: null,
      is_app: deviceType.isApp,
      is_weixin: deviceType.isWeiXin,
      rTitle: "常见疾病",
      sex_id: 0,
      sort_index: 0,
      show: false,
      zyzk_show: false
    };
  },
  created() {
    if(this.$route.query.show_logo == '1'){
      this.zyzk_show = true;
    }
    let sex = this.$route.query.sex;
    if(sex){
      this.sex_id = parseInt(sex);
    }
    this.loadinti();
    window.appBack = ()=> this.pageback();
  },
  methods: {
    logoHide(){
      this.zyzk_show = !this.zyzk_show;
    },
    loadinti(){
      var that = this;
      http.get("/zhen/diagnose").then(function(res) {
        that.locData = res.data;
        var current_first_sort = that.locData.classifier.root.children[0].children[that.sex_id].children;

        for (var i = current_first_sort.length - 1; i >= 0; i--) {
          if(that.sex_id == 1 && current_first_sort[i].text == '心胸'){
            current_first_sort[i].icon = 'xxv'
          }else{
            current_first_sort[i].icon = that.locData.icons[current_first_sort[i].text];
          }
        }

        that.rTitle = current_first_sort[0].text;
        that.categories = current_first_sort[0].children;
        that.sorts = current_first_sort.slice(1,current_first_sort.length);
        that.diseases = current_first_sort[1].children;
        that.show = true;
        that.$appUtils.appCloseLoadingView();
        if(that.$route.query.show_logo == '1'){
          that.logoHide();
        }
      }).catch(function (error) {
        console.log(error)
        //that.loadinti();
      });
    },
    menuClick(index, type){
      if(type == 0){
        let current_first_sort = this.locData.classifier.root.children[0].children[index].children;
        for (let i = current_first_sort.length - 1; i >= 0; i--) {
          if(this.sex_id == 1 && current_first_sort[i].text == '心胸'){
            current_first_sort[i].icon = 'xxv'
          }else{
            current_first_sort[i].icon = this.locData.icons[current_first_sort[i].text];
          }
        }
        this.sex_id = index;
        this.sort_index = 0;
        this.categories = current_first_sort[0].children;
        this.sorts = current_first_sort.slice(1,current_first_sort.length);
        this.diseases = current_first_sort[1].children;

      }else if(type == 1){
        let current_first_sort = this.locData.classifier.root.children[0].children[this.sex_id].children;
        for (let i = current_first_sort.length - 1; i >= 0; i--) {
          if(this.sex_id == 1 && current_first_sort[i].text == '心胸'){
            current_first_sort[i].icon = 'xxv'
          }else{
            current_first_sort[i].icon = this.locData.icons[current_first_sort[i].text];
          }
        }
        this.sort_index = index;
        this.diseases = current_first_sort[index+1].children;
      }else{
        this.categories = this.locData.classifier.root.children[0].children[index].children[0].children;
        this.sex_id = index;
      }

    },
    goto(){
      window.open('https://dl.zyzk.jiankanghao.net/')
    },
    question(traceId) {
      this.$router.push({ path: "/question/" + traceId + '?sex=' +  this.sex_id});
    },
    pageback(){
      return null;
    }
  }
}
</script>

